export const ROOT_URL = `${process.env.API_BASE_URL}`;
export const ASSETS_PATH = `${process.env.ASSETS_PATH}`;
export const KYC_TOKEN = "/token/sumsubToken";
